<template>
  <d-modal
    v-if="showModal"
    @close="closeModal"
    class="crm-new-popup institution-prices"
    style="background-color: rgba(0,0,0,0.6)!important;">
    <d-modal-header>
      <d-modal-title>
        <h4
          class="mt-3"
          v-if="date">
          <span style="font-weight: 100">Lista zamówień dla dnia:</span> {{date.slice(8)}} {{date.slice(5, 7) === '01' ? 'Styczeń' : (date.slice(5, 7) === '02' ? 'Luty' : (date.slice(5, 7) === '03' ? 'Marzec' : (date.slice(5, 7) === '04' ? 'Kwiecień' :
          (date.slice(5, 7) === '05' ? 'Maj' : (date.slice(5, 7) === '06' ? 'Czerwiec' : (date.slice(5, 7) === '07' ? 'Lipiec' : (date.slice(5, 7) === '08' ? 'Sierpień' : (date.slice(5, 7) === '09' ? 'Wrzesień' : (
          date.slice(5, 7) === '10' ? 'Październik' : (date.slice(5, 7) === '11' ? 'Listopad' : (date.slice(5, 7) === '12' ? 'Grudzień' : '')))))))))))}}
          {{date.slice(0, 4)}}
        </h4>
        <h4
          class="mt-3"
          v-else>Oczekujące przelewy</h4>
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <table class="table mt-0 mb-0 full-width">
        <thead class="bg-light">
          <tr>
            <th
              scope="col"
              class="border-0">Odbiorca</th>
            <th
              scope="col"
              class="border-0">Kwota</th>
            <th
              scope="col"
              class="border-0">Kierowca</th>
            <th
              scope="col"
              class="border-0">Produkty</th>
            <th
              scope="col"
              class="border-0 text-center">Pudełka</th>
            <th
              scope="col"
              class="border-0 text-center"
              style="width: 190px;">Akcje</th>
          </tr>
        </thead>
        <tbody v-if="orders">
          <tr
            v-for="(order, index) of orders.data"
            :key="'user-' + index">
            <td class="align-middle">
              {{ order.customer_name}}
              <span class="bottom-text">
                <span
                  class="bottom-text-value"
                  style="opacity: 0.5"
                  v-if="order.shop_address && order.shop_post_code && order.shop_city">
                  {{ order.shop_address + ', ' + order.shop_post_code + ' ' + order.shop_city}}
                </span>
              </span>
            </td>
            <td
              class="align-middle"
              style="min-width: 10rem">
              <span :class="getOrderPriceClass(order)">
                {{(order.payment_transferred + order.payment_cash + order.payment_card).toFixed(2)}} / {{ order.price.toFixed(2) }} zł
              </span>
            </td>
            <td
              class="align-middle"
              style="white-space: nowrap">
              {{order.supplier_name}}
            </td>
            <td class="align-middle">
              {{ order.order_products.length }}
            </td>
            <td class="align-middle text-center">
              <span
                class="text-primary">
                {{ order.containers_number }}
              </span>
            </td>
            <td class="align-middle">
              <d-button
                v-if="!order.is_completed_weighting"
                theme="light"
                @click.prevent="openWeighingModule(order.id, order.supplier_id, order)"
                :class="{ 'partiallyWeightedBg' : isPartiallyWeighted(order)}"
                class="mr-2 action-button"
                title="Ważenie">
                <i
                  class="material-icons"
                  style="transform: rotate(360deg); margin-left: 0.2rem">keyboard_capslock</i>
              </d-button>
              <d-button
                v-if="order.is_completed_weighting && ((order.payment_cash !== order.price) && (order.payment_transferred !== order.price) && (order.payment_card !== order.price))"
                theme="warning"
                @click.prevent="openModalPayment(order)"
                class="mr-2 action-button"
                title="Płatność">
                <i
                  class="material-icons"
                  style="transform: rotate(360deg); margin-left: 0.2rem">euro_symbol</i>
              </d-button>
              <d-button
                theme="primary"
                @click.native="$router.push('/zamowienia/edycja/' + order.id)"
                class="mr-2 action-button"
                title="Edytuj">
                <i class="material-icons">edit</i>
              </d-button>
              <d-button
                v-if="remove"
                theme="danger"
                @click.native="removeOrder(order.id)"
                title="Usuń action-button">
                <i class="material-icons">delete</i>
              </d-button>
            </td>
          </tr>
          <tr v-if="orders.data.length === 0">
            <td
              colspan="6"
              class="text-center">
              Brak zamówień do wyświetlenia&hellip;
            </td>
          </tr>
        </tbody>
      </table>
      <orders-weighing-module
        :key="'weighing-' + show_weighing_module_key"
        :close-modal="closeWeighingModule"
        :is-edit="show_weighing_module_edit"
        :refresh-list="refresh"
        :order="show_weighing_module_data"
        :show-modal="show_weighing_module"
        :supplier="id_supplier"/>

      <orders-form-payment
        :key="show_payment_module_key"
        :close-modal="closeModalPayment"
        :current-order="payment_module_order"
        :refresh="refresh"
        :show-modal="show_payment_module" />
    </d-modal-body>
  </d-modal>
</template>

<script>
import OrdersFormPayment from '@/components/forms/orders/OrdersFormPayment';
import OrdersWeighingModule from '@/views/Orders/OrdersWeighingModule';

export default {
  name: 'dashboard-orders',
  components: {
    OrdersFormPayment,
    OrdersWeighingModule
  },
  data () {
    return {
      show_payment_module_key: 0,
      payment_module_order: {},
      customer_settlement_method: '',
      show_payment_module: false,
      show_weighing_module: false,
      show_weighing_module_data: [],
      show_weighing_module_key: 0,
      show_weighing_module_edit: '',
      id_supplier: 0
    };
  },
  props: {
    showModal: {
      type: Boolean,
      required: true
    },
    remove: {
      type: Boolean
    },
    closeModal: {
      type: Function,
      required: true
    },
    refresh: {
      type: Function,
      required: true
    },
    orders: {
      type: [Array, Object],
      required: true
    },
    date: {
      type: [String, Number]
    }
  },
  methods: {
    openModalPayment (order) {
      this.payment_module_order = order;
      this.show_payment_module = true;
    },
    closeModalPayment () {
      this.show_payment_module = false;
      this.payment_module_order = {};
    },
    getOrderPriceClass (order) {
      if (order.payment_cash === 0 && order.payment_transferred === 0 && order.payment_card === 0) {
        return 'order-payments-red';
      }

      if (order.payment_cash !== 0) {
        if (order.payment_cash !== order.price) {
          return 'order-payments-blue';
        }

        return 'order-payments-green';
      }

      if (order.payment_transferred !== 0) {
        if (order.payment_transferred !== order.price) {
          return 'order-payments-blue';
        }

        return 'order-payments-green';
      }

      if (order.payment_card !== 0) {
        if (order.payment_card !== order.price) {
          return 'order-payments-blue';
        }

        return 'order-payments-green';
      }

      return 'order-payments-red';
    },
    openWeighingModule (id, supplier, data) {
      this.show_weighing_module = true;
      this.show_weighing_module_edit = id;
      this.show_weighing_module_data = data;
      this.id_supplier = supplier;
    },
    closeWeighingModule () {
      this.show_weighing_module = false;
      this.show_weighing_module_edit = '';
      this.show_weighing_module_key += 1;
      this.show_weighing_module_data = [];
      this.refresh();
    },
    isPartiallyWeighted (order) {
      let toWeight = 0;
      const reduced = order.products.reduce((accumulator, product) => {
        if (product.weighing_required === 1) {
          toWeight++;
        }
        if (product.weighing_required === 1 && Number(product.weight) > 0) {
          accumulator += 1;
        }
        return accumulator;
      }, 0);
      return reduced > 0 && reduced < toWeight && toWeight > 1;
    }
  }
};
</script>

<style lang="scss">
  .institution-prices {
    .modal-dialog {
      .modal-content {
        width: 130%;
        .modal-body {
          overflow: auto;
          max-height: 760px;
        }
      }
    }
  }
</style>
